import { createContext, useContext, useMemo } from 'react';
import type { ReactNode } from 'react';
import type { PlatformRuntime } from './contracts';
import { createDefaultPlatformRuntime } from './hostAdapters';

const defaultPlatformRuntime = createDefaultPlatformRuntime();

const PlatformRuntimeContext = createContext<PlatformRuntime>(defaultPlatformRuntime);

interface PlatformRuntimeProviderProps {
  children: ReactNode;
  runtime?: PlatformRuntime;
}

export function PlatformRuntimeProvider({ children, runtime }: PlatformRuntimeProviderProps) {
  const resolvedRuntime = useMemo(() => runtime ?? defaultPlatformRuntime, [runtime]);
  return (
    <PlatformRuntimeContext.Provider value={resolvedRuntime}>
      {children}
    </PlatformRuntimeContext.Provider>
  );
}

export function usePlatformRuntime(): PlatformRuntime {
  return useContext(PlatformRuntimeContext);
}
